import { fetchMqttInfo } from '@/api/api.APP_TARGET';
import { ERR_MQTT_DISCONNECTED, ERR_CLIENT_NOTFOUND } from '@/js/utils';
import Logger from '@/js/logger';

const setMqttClient = ({ state, commit }, payload) => {
  if (!state.connState) {
    return fetchMqttInfo().then((mqttInfo) => {
      commit('SET_MQTT_CLIENT', { ...mqttInfo, ...payload });
    });
  }
};

const setMqttLoading = ({ state, commit }, payload) => {
  commit('SET_MQTT_LOADING', payload);
};

const setMqttData = (
  { commit, rootState },
  { destinationName, payloadString }
) => {
  try {
    commit('SET_MQTT_DATA', {
      destinationName,
      payloadString,
      portsState: rootState.ports.portsData,
    });
  } catch (err) {
    // console.log(err)
    return Promise.reject(err);
  }
};

const clearMqttData = ({ commit }, uid) => {
  commit('CLEAR_MQTT_DATA', uid);
};

const reduceMqttData = ({ commit }, { uid, port_id }) => {
  commit('REDUCE_MQTT_DATA', { uid, port_id });
};

const setClientInfo = ({ commit }, payload) => {
  commit('SET_CLIENT_INFO', payload);
};

const stopConnection = ({ commit }) => {
  commit('SET_CONN_STATE', false);
};

const startConnection = ({ commit }) => {
  commit('SET_CONN_STATE', true);
};

const subscribeDownloadTopic = ({ commit }, topic) => {
  commit('SET_DOWNLOAD_TOPIC', topic);
};

const clearDownloadUrl = ({ commit }, uid) => {
  commit('CLEAR_DOWNLOAD_URL', uid);
};

const sendMqttConfig = ({ commit }, payload) => {
  try {
    commit('SEND_MQTT_CONFIG', payload);
  } catch (err) {
    return Promise.reject(err);
  }
};

const reduceSettingUpdate = ({ commit }, dev_id) => {
  commit('REDUCE_SETTING_UPDATE', dev_id);
};

const clearDeregisteredDevice = ({ commit }, dev_id) => {
  commit('REMOVE_MQTT_DEVICE', dev_id);
};

const subscribeMqttData = ({ state }, { uid, isForced }) => {
  if (!state.connState) return Promise.reject(new Error(ERR_MQTT_DISCONNECTED));
  const mqttInfo = state.clientList.find(
    (el) => el.mac_addr === uid || el.dev_id === uid
  );
  if (!mqttInfo) {
    Logger.warn(ERR_CLIENT_NOTFOUND, uid);
    return; // Promise.reject(new Error(ERR_CLIENT_NOTFOUND));
  }
  if (!mqttInfo.isSubscribed) {
    Logger.info({ mqttInfo });
    state.mqttClient.subscribeTopic(mqttInfo.stateTopic);
    state.mqttClient.subscribeTopic(mqttInfo.readTopic);
    state.mqttClient.subscribeTopic(mqttInfo.resDeviceTopic);
    // if (mqttInfo.mqtt2mbusTopic) {
    //  state.mqttClient.subscribeTopic(mqttInfo.mqtt2mbusTopic);
    // state.mqttClient.subscribeTopic(mqttInfo.mbus2mqttTopic);
    // } else {
  }
  if (isForced || !mqttInfo.isSubscribed) {
    state.mqttClient.publishTopic(mqttInfo.reqTopic);
    // }
    mqttInfo.isSubscribed = true;
  }
};

const activateAlarmState = ({ commit }, payload) => {
  commit('ACTIVATE_ALARM_STATE', payload);
};

const deactivateAlarmState = ({ commit }, payload) => {
  commit('DEACTIVATE_ALARM_STATE', payload);
};

const sendMqttCommand = ({ state }, payload) => {
  if (!state.connState) return Promise.reject(new Error(ERR_MQTT_DISCONNECTED));
  return state.mqttClient.publishTopic(
    state.clientList.find((el) => el.mac_addr === payload.uid).writeTopic,
    payload.data
  );
};

const sendMqttRebootCmd = ({ state }, payload) => {
  if (!state.connState) return Promise.reject(new Error(ERR_MQTT_DISCONNECTED));
  return state.mqttClient.publishTopic(
    state.clientList.find((el) => el.mac_addr === payload.uid).cmdTopic,
    payload.data
  );
};

const sendMqtt2MbusData = ({ state }, payload) => {
  if (!state.connState) return Promise.reject(new Error(ERR_MQTT_DISCONNECTED));
  Logger.info(
    'payload.data',
    payload,
    state.clientList.find((el) => el.mac_addr === payload.uid).mqtt2mbusTopic
  );
  return state.mqttClient.publishTopic(
    state.clientList.find((el) => el.mac_addr === payload.uid).mqtt2mbusTopic,
    payload.data
  );
};

const sendFwRequest = ({ commit }, payload) => {
  try {
    commit('SEND_FW_REQUEST', payload);
  } catch (err) {
    return Promise.reject(new Error(err));
  }
};

export default {
  setClientInfo,
  setMqttData,
  clearMqttData,
  reduceMqttData,
  setMqttClient,
  setMqttLoading,
  stopConnection,
  startConnection,
  sendMqttConfig,
  reduceSettingUpdate,
  sendMqttCommand,
  sendMqttRebootCmd,
  sendMqtt2MbusData,
  sendFwRequest,
  clearDeregisteredDevice,
  subscribeMqttData,
  activateAlarmState,
  deactivateAlarmState,
  subscribeDownloadTopic,
  clearDownloadUrl,
};
